var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    attrs: {
      "flat": ""
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-data-table', _vm._b({
    ref: "data-table",
    attrs: {
      "items-per-page": -1,
      "height": "400",
      "fixed-header": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([!_vm.isCreate ? {
      key: "body",
      fn: function fn(props) {
        return [_vm.$refs['data-table'] ? _c('draggable', {
          attrs: {
            "tag": "tbody",
            "list": props.items,
            "sort": !_vm.loading
          },
          on: {
            "change": _vm.setNewIndex
          }
        }, [_c('v-nodes', {
          attrs: {
            "vnodes": _vm.$refs['data-table'].genItems(props.items, props)
          }
        })], 1) : _vm._e()];
      }
    } : null, _vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: "item.WORK_TYPE",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-select', _vm._b({
          attrs: {
            "items": _vm.workTypes
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.WORK_TYPE,
            callback: function callback($$v) {
              _vm.$set(item, "WORK_TYPE", $$v);
            },
            expression: "item.WORK_TYPE"
          }
        }, 'v-select', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.BOM_LEVEL",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "type": "number"
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.BOM_LEVEL,
            callback: function callback($$v) {
              _vm.$set(item, "BOM_LEVEL", $$v);
            },
            expression: "item.BOM_LEVEL"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.ITEM_LEVEL",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('v-select', _vm._b({
          attrs: {
            "items": _vm.itemLevels
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.ITEM_LEVEL,
            callback: function callback($$v) {
              _vm.$set(item, "ITEM_LEVEL", $$v);
            },
            expression: "item.ITEM_LEVEL"
          }
        }, 'v-select', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.ITEMSEQ",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "type": "number",
            "readonly": ""
          },
          model: {
            value: item.ITEMSEQ,
            callback: function callback($$v) {
              _vm.$set(item, "ITEMSEQ", $$v);
            },
            expression: "item.ITEMSEQ"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.WORK_SIDE",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('v-select', _vm._b({
          attrs: {
            "items": _vm.workSides
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.WORK_SIDE,
            callback: function callback($$v) {
              _vm.$set(item, "WORK_SIDE", $$v);
            },
            expression: "item.WORK_SIDE"
          }
        }, 'v-select', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.ITEM_CODE_P",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.ITEM_CODE_P,
            callback: function callback($$v) {
              _vm.$set(item, "ITEM_CODE_P", $$v);
            },
            expression: "item.ITEM_CODE_P"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.ITEM_NAME",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.ITEM_NAME,
            callback: function callback($$v) {
              _vm.$set(item, "ITEM_NAME", $$v);
            },
            expression: "item.ITEM_NAME"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.ITEM_CODE",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.ITEM_CODE,
            callback: function callback($$v) {
              _vm.$set(item, "ITEM_CODE", $$v);
            },
            expression: "item.ITEM_CODE"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.CLASS_CODE",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.CLASS_CODE,
            callback: function callback($$v) {
              _vm.$set(item, "CLASS_CODE", $$v);
            },
            expression: "item.CLASS_CODE"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.CLASS_NAME",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.CLASS_NAME,
            callback: function callback($$v) {
              _vm.$set(item, "CLASS_NAME", $$v);
            },
            expression: "item.CLASS_NAME"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.ITEM_TYPE",
      fn: function fn(_ref12) {
        var item = _ref12.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.ITEM_TYPE,
            callback: function callback($$v) {
              _vm.$set(item, "ITEM_TYPE", $$v);
            },
            expression: "item.ITEM_TYPE"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.ITEM_TYPE_NAME",
      fn: function fn(_ref13) {
        var item = _ref13.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.ITEM_TYPE_NAME,
            callback: function callback($$v) {
              _vm.$set(item, "ITEM_TYPE_NAME", $$v);
            },
            expression: "item.ITEM_TYPE_NAME"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.REVISION",
      fn: function fn(_ref14) {
        var item = _ref14.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.REVISION,
            callback: function callback($$v) {
              _vm.$set(item, "REVISION", $$v);
            },
            expression: "item.REVISION"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.RANK",
      fn: function fn(_ref15) {
        var item = _ref15.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.RANK,
            callback: function callback($$v) {
              _vm.$set(item, "RANK", $$v);
            },
            expression: "item.RANK"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.UNIT_QTY",
      fn: function fn(_ref16) {
        var item = _ref16.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "type": "number"
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.UNIT_QTY,
            callback: function callback($$v) {
              _vm.$set(item, "UNIT_QTY", $$v);
            },
            expression: "item.UNIT_QTY"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.CREATE_DATE",
      fn: function fn(_ref17) {
        var item = _ref17.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.CREATE_DATE,
            callback: function callback($$v) {
              _vm.$set(item, "CREATE_DATE", $$v);
            },
            expression: "item.CREATE_DATE"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.MAKER_PARTNO",
      fn: function fn(_ref18) {
        var item = _ref18.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.MAKER_PARTNO,
            callback: function callback($$v) {
              _vm.$set(item, "MAKER_PARTNO", $$v);
            },
            expression: "item.MAKER_PARTNO"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.SPEC",
      fn: function fn(_ref19) {
        var item = _ref19.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.SPEC,
            callback: function callback($$v) {
              _vm.$set(item, "SPEC", $$v);
            },
            expression: "item.SPEC"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.MAKER_NAME",
      fn: function fn(_ref20) {
        var item = _ref20.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.MAKER_NAME,
            callback: function callback($$v) {
              _vm.$set(item, "MAKER_NAME", $$v);
            },
            expression: "item.MAKER_NAME"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.SUPPLIER_NAME",
      fn: function fn(_ref21) {
        var item = _ref21.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "readonly": ""
          },
          model: {
            value: item.SUPPLIER_NAME,
            callback: function callback($$v) {
              _vm.$set(item, "SUPPLIER_NAME", $$v);
            },
            expression: "item.SUPPLIER_NAME"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.DATE_FR",
      fn: function fn(_ref22) {
        var item = _ref22.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "type": "date",
            "readonly": ""
          },
          model: {
            value: item.DATE_FR,
            callback: function callback($$v) {
              _vm.$set(item, "DATE_FR", $$v);
            },
            expression: "item.DATE_FR"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }, {
      key: "item.DATE_TO",
      fn: function fn(_ref23) {
        var item = _ref23.item;
        return [_c('v-text-field', _vm._b({
          attrs: {
            "type": "date",
            "readonly": ""
          },
          model: {
            value: item.DATE_TO,
            callback: function callback($$v) {
              _vm.$set(item, "DATE_TO", $$v);
            },
            expression: "item.DATE_TO"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs__field), false))];
      }
    }], null, true)
  }, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }